import { render, staticRenderFns } from "./AnagraficaSearch.vue?vue&type=template&id=00fae544&scoped=true&"
import script from "./AnagraficaSearch.vue?vue&type=script&lang=ts&"
export * from "./AnagraficaSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AnagraficaSearch.vue?vue&type=style&index=0&id=00fae544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fae544",
  null
  
)

export default component.exports